"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var format_money_1 = require("../helpers/format-money");
var TicketPlayed = (function () {
    function TicketPlayed(subTickets, ticketsHolder, hasJackpot) {
        if (hasJackpot === void 0) { hasJackpot = false; }
        this.ticketID = "";
        this.domId = "";
        this.ticketAmount = "";
        this.numbers = [];
        this.first5Sum = "0";
        this.ballParity = "0";
        this.topColor = [];
        this.firstBallSum = "0";
        this.firstBallParity = "0";
        this.firstColor = [];
        this.lastBallSum = "0";
        this.lastBallParity = "0";
        this.lastColor = [];
        this.allColors = false;
        this.jackpotCode = "";
        this.roundID = "";
        this.currentRound = '';
        this.roundsTotal = '';
        this.winningTicket = false;
        this.hasJackpot = false;
        this.ticketStatus = 0;
        this.itemStatus = 0;
        this.itemGameID = '';
        this.evMinWin = null;
        this.evMaxWin = null;
        this.winMoney = null;
        this.shareWins = {
            all_colors: '',
            top_color: '',
            matchedNumbers: [],
            first_color: '',
            preballs_sum: '',
            first_ball: '',
            first_five_balls: '',
            last_color: '',
            last_ball: '',
            last_ball_parity: '',
            parity: ''
        };
        this.colors = {
            1: 'red',
            2: 'green',
            3: 'blue',
            4: 'purple',
            5: 'brown',
            6: 'yellow',
            7: 'orange',
            8: 'black'
        };
        this.ballColors = {
            'red': [1, 9, 17, 25, 33, 41],
            'green': [2, 10, 18, 26, 34, 42],
            'blue': [3, 11, 19, 27, 35, 43],
            'purple': [4, 12, 20, 28, 36, 44],
            'brown': [5, 13, 21, 29, 37, 45],
            'yellow': [6, 14, 22, 30, 38, 46],
            'orange': [7, 15, 23, 31, 39, 47],
            'black': [8, 16, 24, 32, 40, 48]
        };
        this.ticketsHolder = ticketsHolder;
        for (var key in subTickets) {
            this.ticketID = subTickets[key]['TicketID'];
            if (subTickets[key]['DisplayId']) {
                this.domId = subTickets[key]['DisplayId'];
            }
            else if (!this.domId) {
                this.domId = this.ticketID;
            }
            this.ticketAmount = subTickets[key]['TicketAmount'];
            this.jackpotCode = subTickets[key]['JPCode'];
            var rowRoundId = subTickets[key]['RoundID'];
            if (rowRoundId !== undefined && rowRoundId !== null && String(rowRoundId) !== '') {
                this.roundID = String(rowRoundId);
            }
            this.hasJackpot = hasJackpot;
            if (subTickets[key]['TicketStatus'] !== undefined
                && subTickets[key]['TicketStatus'] !== null
                && subTickets[key]['TicketStatus'] !== '') {
                var parsedStatus = parseInt(String(subTickets[key]['TicketStatus']), 10);
                if (!isNaN(parsedStatus)) {
                    this.ticketStatus = parsedStatus;
                }
            }
            if (subTickets[key]['ItemGameID'] !== undefined
                && subTickets[key]['ItemGameID'] !== null
                && subTickets[key]['ItemGameID'] !== '') {
                this.itemGameID = String(subTickets[key]['ItemGameID']);
            }
            if (subTickets[key]['ItemStatus'] !== undefined
                && subTickets[key]['ItemStatus'] !== null
                && subTickets[key]['ItemStatus'] !== '') {
                var parsedItemStatus = parseInt(String(subTickets[key]['ItemStatus']), 10);
                if (!isNaN(parsedItemStatus)) {
                    this.itemStatus = parsedItemStatus;
                }
            }
            switch (subTickets[key]['OddType']) {
                case 1:
                    if (subTickets[key]['Numbers'] == "|01|09|17|25|33|41|02|10|18|26|34|42|03|11|19|27|35|43|04|12|20|28|36|44|05|13|21|29|37|45|06|14|22|30|38|46|07|15|23|31|39|47|08|16|24|32|40|48|") {
                        this.allColors = true;
                    }
                    else {
                        this.numbers = this.decodeNumbers(subTickets[key]['Numbers']);
                    }
                    break;
                case 2:
                    this.first5Sum = subTickets[key]['Odd'];
                    break;
                case 3:
                    this.firstBallSum = subTickets[key]['Odd'];
                    break;
                case 4:
                    this.firstBallParity = subTickets[key]['Odd'];
                    break;
                case 5:
                    this.firstColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
                case 6:
                    this.ballParity = subTickets[key]['Odd'];
                    break;
                case 7:
                    this.topColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
                case 8:
                    this.lastBallSum = subTickets[key]['Odd'];
                    break;
                case 9:
                    this.lastBallParity = subTickets[key]['Odd'];
                    break;
                case 10:
                    this.lastColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
            }
        }
        if (!this.domId) {
            this.domId = this.ticketID;
        }
        this.applySubscriptionRoundMeta(subTickets);
        this.applyEventualWinMeta(subTickets);
    }
    TicketPlayed.prototype.applySubscriptionRoundMeta = function (subTickets) {
        var roundsTotal = '';
        var minCurrent = null;
        for (var key in subTickets) {
            var rt = subTickets[key]['RoundsTotal'];
            if (roundsTotal === '' && rt !== undefined && rt !== null && rt !== '') {
                roundsTotal = String(rt);
            }
            var cr = subTickets[key]['CurrentRound'];
            if (cr === undefined || cr === null || cr === '') {
                continue;
            }
            var crNum = parseInt(String(cr), 10);
            if (isNaN(crNum)) {
                continue;
            }
            if (minCurrent === null || crNum < minCurrent) {
                minCurrent = crNum;
            }
        }
        var totalNum = parseInt(roundsTotal, 10);
        var currentNum = minCurrent !== null ? minCurrent : NaN;
        if (!isNaN(totalNum) && totalNum > 1) {
            if (isNaN(currentNum) || currentNum < 1) {
                currentNum = 1;
            }
            if (currentNum > totalNum) {
                currentNum = totalNum;
            }
            this.roundsTotal = String(totalNum);
            this.currentRound = String(currentNum);
            return;
        }
        this.roundsTotal = roundsTotal;
        this.currentRound = minCurrent !== null ? String(minCurrent) : '';
    };
    TicketPlayed.prototype.applyEventualWinMeta = function (subTickets) {
        var minWin = null;
        var maxWin = null;
        var winMoney = 0;
        var hasWinMoney = false;
        for (var key in subTickets) {
            var row = subTickets[key];
            var apiMin = parseFloat(String(row['ItemEvMinWin']));
            if (!isNaN(apiMin) && apiMin > 0) {
                minWin = minWin === null ? apiMin : Math.min(minWin, apiMin);
            }
            var apiMaxRaw = row['ItemEvMaxWin'] != null && row['ItemEvMaxWin'] !== ''
                ? row['ItemEvMaxWin']
                : row['ItemEvWin'];
            var apiMax = parseFloat(String(apiMaxRaw));
            if (!isNaN(apiMax) && apiMax > 0) {
                maxWin = maxWin === null ? apiMax : maxWin + apiMax;
            }
            var rowWin = parseFloat(String(row['ItemWinMoney']));
            if (!isNaN(rowWin) && rowWin > 0) {
                winMoney += rowWin;
                hasWinMoney = true;
            }
        }
        this.evMinWin = minWin;
        this.evMaxWin = maxWin;
        this.winMoney = hasWinMoney ? winMoney : null;
    };
    TicketPlayed.prototype.compareNumbers = function (a, b) {
        return a - b;
    };
    TicketPlayed.prototype.ball2Color = function (ballNumber) {
        for (var key in this.ballColors) {
            var index = this.ballColors[key].indexOf(ballNumber);
            if (index !== -1) {
                return key;
            }
        }
        return false;
    };
    TicketPlayed.prototype.isEven = function (n) {
        return n % 2 == 0;
    };
    TicketPlayed.prototype.decodeNumbers = function (numbersString) {
        var numbers = numbersString.split('|');
        delete numbers[numbers.length - 1];
        delete numbers[0];
        var numbersNew = [];
        for (var x in numbers) {
            numbersNew.push(parseInt(numbers[x]));
        }
        return numbersNew;
    };
    TicketPlayed.prototype.decodeColors = function (colorString) {
        var colorArray = [];
        for (var i = 0; i < colorString.length; i++) {
            colorArray.push(this.number2color(parseInt(colorString.charAt(i))));
        }
        return colorArray;
    };
    TicketPlayed.prototype.number2color = function (colorCode) {
        return this.colors[colorCode];
    };
    TicketPlayed.prototype.markEl = function (suffix, className) {
        var el = document.getElementById(this.domId + '-' + suffix);
        if (el) {
            el.classList.add(className);
        }
        return el;
    };
    TicketPlayed.prototype.update = function () {
        this.syncCurrentRoundMessage();
        if (!this.canApplyDrawMarks()) {
            if (!this.matchesCurrentDraw()) {
                this.clearDrawMarks();
            }
            return;
        }
        var oldWinningStatus = this.winningTicket;
        var drawnNumbers = window['drawnNumbers'];
        var drawnBalls = window['drawnBalls'];
        var drawnOddBalls = window['drawnOddBalls'];
        var drawnEvenBalls = window['drawnEvenBalls'];
        var drawnColors = window['drawnColors'];
        if (this.allColors) {
            for (var key in drawnColors) {
                if (drawnColors[key] >= 6) {
                    this.markEl('all-color-' + key, 'bhr-balls-choosen');
                    this.markEl('all-color-' + key, 'bhr-balls-choosen-' + key);
                    this.winningTicket = true;
                    this.shareWins.all_colors = drawnColors;
                }
            }
        }
        if (typeof drawnNumbers === 'undefined' || drawnNumbers.length == 0) {
            console.info("drawnNumbers is undefined");
            return;
        }
        var matchedNumbers = 0;
        var matchNumbersArr = [];
        for (var i = 0; i < drawnNumbers.length; i++) {
            var ballNumber = drawnNumbers[i];
            var ballElement = document.getElementById(this.domId + '-ball-' + ballNumber);
            if (ballElement !== null) {
                matchedNumbers++;
                matchNumbersArr.push(ballNumber);
                if (ballElement.parentElement) {
                    ballElement.parentElement.classList.add('ticket-ball-bck-drawn');
                }
            }
        }
        if (matchedNumbers >= 6) {
            this.winningTicket = true;
            this.shareWins.matchedNumbers = matchNumbersArr.sort();
        }
        var firstColor = this.ball2Color(drawnNumbers[0]);
        if (this.markEl('first-color-' + firstColor, 'tshs-balls-drawn')) {
            this.winningTicket = true;
            this.shareWins.first_color = firstColor;
        }
        var firstSum = parseInt(drawnNumbers[0]);
        if (this.isEven(firstSum)) {
            if (this.markEl('first-ball-parity-even', 'tsh-cr-down-red-drawn')) {
                this.winningTicket = true;
                this.shareWins.preballs_sum = 'Even';
            }
        }
        else {
            if (this.markEl('first-ball-parity-odd', 'tsh-cr-down-red-drawn')) {
                this.winningTicket = true;
                this.shareWins.preballs_sum = 'Odd';
            }
        }
        if (firstSum < 24.5) {
            if (this.markEl('first-ball-sum-less', 'tsh-cr-down-red-drawn')) {
                this.winningTicket = true;
                this.shareWins.first_ball = 'Less';
            }
        }
        else {
            if (this.markEl('first-ball-sum-more', 'tsh-cr-down-red-drawn')) {
                this.winningTicket = true;
                this.shareWins.first_ball = 'More';
            }
        }
        if (drawnBalls >= 5 && drawnNumbers.length >= 5) {
            var sum = parseInt(drawnNumbers[0]) + parseInt(drawnNumbers[1]) + parseInt(drawnNumbers[2]) + parseInt(drawnNumbers[3]) + parseInt(drawnNumbers[4]);
            if (sum < 122.5) {
                if (this.markEl('first-5-sum-less', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.first_five_balls = 'Less';
                }
            }
            else {
                if (this.markEl('first-5-sum-more', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.first_five_balls = 'More';
                }
            }
        }
        if (drawnBalls >= 35) {
            var lastColor = this.ball2Color(drawnNumbers[34]);
            var lastSum = parseInt(drawnNumbers[34]);
            var commonColors = window['getMostCommonColors']();
            for (var key in commonColors) {
                if (this.markEl('top-color-' + commonColors[key], 'tshs-balls-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.top_color = commonColors[key];
                }
            }
            if (this.markEl('last-color-' + lastColor, 'tshs-balls-drawn')) {
                this.winningTicket = true;
                this.shareWins.last_color = lastColor;
            }
            if (lastSum < 24.5) {
                if (this.markEl('last-ball-sum-less', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.last_ball = 'Less';
                }
            }
            else {
                if (this.markEl('last-ball-sum-more', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.last_ball = 'More';
                }
            }
            if (this.isEven(lastSum)) {
                if (this.markEl('last-ball-parity-even', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.last_ball_parity = 'Even';
                }
            }
            else {
                if (this.markEl('last-ball-parity-odd', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.last_ball_parity = 'Odd';
                }
            }
            if (drawnOddBalls > drawnEvenBalls) {
                if (this.markEl('ball-parity-odd', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.parity = 'Odd';
                }
            }
            else {
                if (this.markEl('ball-parity-even', 'tsh-cr-down-red-drawn')) {
                    this.winningTicket = true;
                    this.shareWins.parity = 'Even';
                }
            }
        }
        if (this.winningTicket === true && oldWinningStatus !== true) {
            this.ticketsHolder.markWinningTicket(this.domId);
        }
    };
    TicketPlayed.prototype.matchesCurrentDraw = function () {
        var drawGameId = String(window['drawnNumbersGameId']
            || window['currentDrawGameId']
            || '');
        if (this.itemGameID && drawGameId && String(this.itemGameID) === drawGameId) {
            return true;
        }
        var ticketRound = String(this.roundID || '');
        if (!ticketRound || ticketRound === 'undefined' || ticketRound === 'null') {
            return false;
        }
        var getGame = window['responseHandler'] && window['responseHandler'].getGame;
        var drawRound = String(window['drawnNumbersForRound']
            || window['currentDrawRoundToday']
            || window['todayRoundId']
            || window['globalCurrentGameId']
            || (getGame && getGame.ID_Today)
            || '');
        if (!drawRound) {
            return false;
        }
        return ticketRound === drawRound;
    };
    TicketPlayed.prototype.canApplyDrawMarks = function () {
        if (!this.matchesCurrentDraw()) {
            return false;
        }
        var drawnNumbers = window['drawnNumbers'];
        if (typeof drawnNumbers === 'undefined' || drawnNumbers.length === 0) {
            return false;
        }
        return true;
    };
    TicketPlayed.prototype.shouldShowCurrentRoundMessage = function () {
        var rtNum = parseInt(this.roundsTotal, 10);
        if (isNaN(rtNum) || rtNum <= 1) {
            return false;
        }
        if (this.itemStatus !== 0) {
            return false;
        }
        return this.matchesCurrentDraw();
    };
    TicketPlayed.prototype.syncCurrentRoundMessage = function () {
        var msg = document.getElementById(this.domId + '-current-round');
        if (!msg) {
            return;
        }
        msg.style.display = this.shouldShowCurrentRoundMessage() ? '' : 'none';
    };
    TicketPlayed.prototype.clearDrawMarks = function () {
        this.syncCurrentRoundMessage();
        var root = document.getElementById('ticket-' + this.domId);
        if (!root) {
            return;
        }
        root.querySelectorAll('.ticket-ball-bck-drawn').forEach(function (el) {
            el.classList.remove('ticket-ball-bck-drawn');
        });
        root.querySelectorAll('.tsh-cr-down-red-drawn').forEach(function (el) {
            el.classList.remove('tsh-cr-down-red-drawn');
        });
        root.querySelectorAll('.tshs-balls-drawn').forEach(function (el) {
            el.classList.remove('tshs-balls-drawn');
        });
        root.querySelectorAll('[class*="bhr-balls-choosen"]').forEach(function (el) {
            el.className = el.className.replace(/\bbhr-balls-choosen[^\s]*/g, '').trim();
        });
    };
    TicketPlayed.prototype.getSharedWinsData = function () {
        return this.shareWins;
    };
    TicketPlayed.prototype.getWinStatus = function () {
        return this.winningTicket;
    };
    TicketPlayed.prototype.getDisplayStatus = function () {
        return this.itemStatus;
    };
    TicketPlayed.prototype.getTicketStatusClass = function () {
        var status = this.getDisplayStatus();
        if (status === 2) {
            return ' lost-ticket';
        }
        if (status === 3 || status === 4) {
            return ' winning-ticket';
        }
        return '';
    };
    TicketPlayed.prototype.getWinInfoHtml = function (translation) {
        var inner = '';
        var currency = window['currency'];
        if (this.evMaxWin !== null || this.evMinWin !== null) {
            var maxLabel = translation['potential_maximal_win_b49']
                || translation['potential_maximal_win']
                || 'Eventualni max dobitak';
            var minLabel = translation['potential_minimal_win_b49']
                || translation['potential_minimal_win']
                || 'Eventualni min dobitak';
            if (this.evMinWin !== null) {
                inner += '<div class="tsh-title tsh-title-lb-win"><span>' + minLabel + ': '
                    + format_money_1.formatMoneyAmount(this.evMinWin) + ' ' + currency + '</span></div>';
            }
            if (this.evMaxWin !== null) {
                inner += '<div class="tsh-title tsh-title-lb-win"><span>' + maxLabel + ': '
                    + format_money_1.formatMoneyAmount(this.evMaxWin) + ' ' + currency + '</span></div>';
            }
        }
        if (this.winMoney !== null && this.winMoney > 0) {
            var winLabel = translation['ticket_winnings'] || translation['win_amount'] || 'Dobitak';
            inner += '<div class="tsh-title tsh-title-lb-win"><span>' + winLabel + ': '
                + format_money_1.formatMoneyAmount(this.winMoney) + ' ' + currency + '</span></div>';
        }
        if (!inner) {
            return '';
        }
        return '<div class="ticket-statistic-holder ticket-win-info">' + inner + '</div>';
    };
    TicketPlayed.prototype.getHTML = function (key) {
        var translation = window['langArr'][window['language']];
        var jackpotClass = '';
        if (this.hasJackpot) {
            jackpotClass = ' lb-jackpot-ticket';
        }
        var html = '<div class="ticket-holder' + jackpotClass + this.getTicketStatusClass() + '" id="ticket-' + this.domId + '">\
							<div class="ticket-share-confirm" id="ticket-share-confirm' + key + '">\
							<div>\
							<div>' + translation['sure2share'] + '</div>\
							<div class="tsc-yn"><span class="shareConfirmYes" data-sharekey=' + key + '>' + translation['yes'] + '</span><span class="shareConfirmNo"  data-sharekey=' + key + '>' + translation['no'] + '</span></div>\
							</div>\
							</div>\
                            <div class="ticket-bar clearfix">\
								<div class="ticket-bar-left">' + translation['ticket_id'] + ' : ' + this.ticketID + '</div>\
								<div class="ticket-bar-right"><img id="shareButton-' + this.domId + '" class="ticket-share-image" data-sharekey = ' + key + ' src="../shared/img/share.svg" title="' + translation['Share'] + '" /> </div>\
                                <div class="ticket-bar-right">' + this.ticketAmount + ' ' + window['currency'] + '</div>\
                            </div>\
                            <div class="ticket-content luckyballs-ticket">';
        var hasBallSection = this.allColors || (this.numbers && this.numbers.length > 0);
        if (hasBallSection) {
            html += '<div class="ticket-ball-holder">';
            if (this.allColors === false) {
                this.numbers.sort(this.compareNumbers);
                for (var key_1 in this.numbers) {
                    var ball = document.getElementById('ball' + this.numbers[key_1]);
                    if (null !== ball) {
                        var clone = ball.cloneNode(true);
                        $(clone).attr('id', this.domId + '-ball-' + this.numbers[key_1]);
                        $(clone).removeClass('clickable-ball');
                        html += '                       <div class="ticket-ball-bck">';
                        html += clone.outerHTML;
                        html += '                       <div class="kvacica"></div></div>';
                    }
                }
            }
            else {
                html += '<div class="bhr-content" style="padding: 0 30px 0 30px;">\
                                    <div class="bhr-balls" data-color="red" id="' + this.domId + '-all-color-red"><img alt="red-ball" src="img/red-ball.png"></div>\
                                    <div class="bhr-balls" data-color="green" id="' + this.domId + '-all-color-green"><img alt="green-ball" src="img/green-ball.png"></div>\
                                    <div class="bhr-balls" data-color="blue" id="' + this.domId + '-all-color-blue"><img alt="blue-ball" src="img/blue-ball.png"></div>\
                                    <div class="bhr-balls" data-color="purple" id="' + this.domId + '-all-color-purple"><img alt="purple-ball" src="img/purple-ball.png"></div>\
                                    <div class="bhr-balls" data-color="brown" id="' + this.domId + '-all-color-brown"><img alt="brown-ball" src="img/brown-ball.png"></div>\
                                    <div class="bhr-balls" data-color="yellow" id="' + this.domId + '-all-color-yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>\
                                    <div class="bhr-balls" data-color="orange" id="' + this.domId + '-all-color-orange"><img alt="orange-ball" src="img/orange-ball.png"></div>\
                                    <div class="bhr-balls" data-color="black" id="' + this.domId + '-all-color-black"><img alt="black-ball" src="img/black-ball.png"></div>\
                                </div>';
            }
            html += '</div>';
        }
        var showRoundMsg = this.shouldShowCurrentRoundMessage();
        if (!showRoundMsg) {
            html += '                    <div class="ticket-statistic-holder">\
                                            <div class="tsh-title"><span>' + translation['all'] + '<span></div>\
                                                <div class="tsh-content">\
                                                    <div class="tsh-content-left">\
                                                        <div class="tshs-cl-text">' + translation['common_color'] + '</div>\
                                                        <div class="tshs-balls-holder">';
        }
        else {
            html += '                    <div class="ticket-statistic-holder">\
                                <div class="tsh-title" id="' + this.domId + '-current-round"><span>' + translation['current_round'] + ': ' + this.currentRound + ' of </span><span>' + this.roundsTotal + ' ' + translation['rounds_total'] + '</span></div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['common_color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        }
        for (var key_2 in this.topColor) {
            html += '                               <div class="tshs-balls ' + this.topColor[key_2] + '-ball" id="' + this.domId + '-top-color-' + this.topColor[key_2] + '"></div>';
        }
        for (var key_3 = 0; key_3 < 4 - this.topColor.length; key_3++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '                               </div>';
        html += '                           </div>\
                                        <div class="tsh-content-right" style="width: 58%;">\
                                            <div class="tsh-cr-up">\
                                                <span>' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.ballParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-ball-parity-even' + '"';
        }
        html += '>' + translation['more_even'] + '</span>\
                                                <span ';
        if (this.ballParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-ball-parity-odd' + '"';
        }
        html += '>' + translation['more_odd'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['first_five_balls'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-middle">\
                                            <div class="tsh-cr-up">\
                                                <span>122.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.first5Sum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-5-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.first5Sum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-5-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['first_ball'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        for (var key_4 in this.firstColor) {
            html += '                               <div class="tshs-balls ' + this.firstColor[key_4] + '-ball" id="' + this.domId + '-first-color-' + this.firstColor[key_4] + '"></div>';
        }
        for (var key_5 = 0; key_5 < 4 - this.firstColor.length; key_5++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '                                </div>\
                                        </div>\
                                        <div class="tsh-content-middle ths-cm-left">\
                                            <div class="tsh-cr-up">\
                                                <span>' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.firstBallParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-ball-parity-even' + '"';
        }
        html += '>' + translation['even'] + '</span>\
                                                <span ';
        if (this.firstBallParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-ball-parity-odd' + '"';
        }
        html += '>' + translation['odd'] + '</span>\
                                            </div>\
                                        </div>\
                                        <div class="tsh-content-right">\
                                            <div class="tsh-cr-up">\
                                                <span>24.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.firstBallSum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-ball-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.firstBallSum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-first-ball-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['last_ball'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        for (var key_6 in this.lastColor) {
            html += '                               <div class="tshs-balls ' + this.lastColor[key_6] + '-ball" id="' + this.domId + '-last-color-' + this.lastColor[key_6] + '"></div>';
        }
        for (var key_7 = 0; key_7 < 4 - this.lastColor.length; key_7++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '</div>\
                                        </div>\
                                        <div class="tsh-content-middle ths-cm-left">\
                                            <div class="tsh-cr-up">\
                                                <span class="tsh-cr-down">' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.lastBallParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-last-ball-parity-even' + '"';
        }
        html += '>' + translation['even'] + '</span>\
                                                <span ';
        if (this.lastBallParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-last-ball-parity-odd' + '"';
        }
        html += '>' + translation['odd'] + '</span>\
                                            </div>\
                                        </div>\
                                        <div class="tsh-content-right">\
                                            <div class="tsh-cr-up">\
                                                <span>24.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.lastBallSum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-last-ball-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.lastBallSum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.domId + '-last-ball-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                ' + this.getWinInfoHtml(translation) + '\
                                <div class="jackpot-code"><span class="tsh-cr-down-red">' + translation['round_no'] + ': ' + this.roundID + ' </span><span class="tsh-cr-down-red"">' + translation['jackpot_code'] + ': ' + this.jackpotCode + '</span></div>\
                            </div>\
                        </div>';
        return html;
    };
    TicketPlayed.prototype.getDrawnNumbers = function () {
        return window['drawnBalls'];
    };
    TicketPlayed.prototype.shareHTML = function () {
        var translation = window['langArr'][window['language']];
        var shareLost = {
            top_color: this.topColor,
            first_color: this.firstColor,
            preballs_sum: '',
            first_ball: '',
            first_five_balls: '',
            last_color: this.lastColor,
            last_ball: '',
            last_ball_parity: '',
            parity: ''
        };
        if (this.firstBallParity == "1") {
            shareLost.first_ball = 'Less';
        }
        if (this.firstBallParity == "2") {
            shareLost.first_ball = 'More';
        }
        if (this.firstBallSum == "1") {
            shareLost.preballs_sum = 'Even';
        }
        if (this.firstBallSum == "2") {
            shareLost.preballs_sum = 'Odd';
        }
        if (this.first5Sum == "1") {
            shareLost.first_five_balls = 'Less';
        }
        if (this.first5Sum == "2") {
            shareLost.first_five_balls = 'More';
        }
        if (this.lastBallSum == "1") {
            shareLost.last_ball = 'Less';
        }
        if (this.lastBallSum == "2") {
            shareLost.last_ball = 'More';
        }
        if (this.lastBallParity == "1") {
            shareLost.last_ball_parity = 'Even';
        }
        if (this.lastBallParity == "2") {
            shareLost.last_ball_parity = 'Odd';
        }
        if (this.ballParity == "1") {
            shareLost.parity = 'Even';
        }
        if (this.ballParity == "2") {
            shareLost.parity = 'Odd';
        }
        var html = '<div class="ticket-holder" >\
							</div>\
                            <div class="ticket-bar clearfix str-ticket-bar-use">\
								<div class="ticket-bar-left">str-left-use</div>\
								<div class="ticket-bar-right">str-lost-use</div>\
                                <div class="ticket-bar-right-after">str-right-use</div>\
                            </div>\
                            <div class="ticket-content">';
        if (this.allColors || (this.numbers && this.numbers.length > 0)) {
            html += '<div class="ticket-ball-holder">';
            if (this.allColors === false) {
                this.numbers.sort(this.compareNumbers);
                var _loop_1 = function (key) {
                    var ball = document.getElementById('ball' + this_1.numbers[key]);
                    var classCss = '';
                    var self_1 = this_1;
                    var drawnNumbers = window['drawnNumbers'];
                    drawnNumbers.forEach(function (match) {
                        if (match === self_1.numbers[key]) {
                            classCss = 'ticket-ball-bck-drawn';
                        }
                    });
                    if (null !== ball) {
                        var clone = ball.cloneNode(true);
                        $(clone).attr('id', this_1.domId + '-ball-' + this_1.numbers[key]);
                        $(clone).removeClass('clickable-ball');
                        html += '                       <div class="ticket-ball-bck ' + classCss + '">';
                        html += clone.outerHTML;
                        html += '                       <div class="kvacica"></div></div>';
                    }
                };
                var this_1 = this;
                for (var key in this.numbers) {
                    _loop_1(key);
                }
            }
            else {
                html += '<div class="bhr-content" style="padding: 0 30px 0 30px;">\
						<div class="bhr-balls" data-color="red" id="' + this.domId + '-all-color-red"><img alt="red-ball" src="img/red-ball.png"></div>\
						<div class="bhr-balls" data-color="green" id="' + this.domId + '-all-color-green"><img alt="green-ball" src="img/green-ball.png"></div>\
						<div class="bhr-balls" data-color="blue" id="' + this.domId + '-all-color-blue"><img alt="blue-ball" src="img/blue-ball.png"></div>\
						<div class="bhr-balls" data-color="purple" id="' + this.domId + '-all-color-purple"><img alt="purple-ball" src="img/purple-ball.png"></div>\
						<div class="bhr-balls" data-color="brown" id="' + this.domId + '-all-color-brown"><img alt="brown-ball" src="img/brown-ball.png"></div>\
						<div class="bhr-balls" data-color="yellow" id="' + this.domId + '-all-color-yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>\
						<div class="bhr-balls" data-color="orange" id="' + this.domId + '-all-color-orange"><img alt="orange-ball" src="img/orange-ball.png"></div>\
						<div class="bhr-balls" data-color="black" id="' + this.domId + '-all-color-black"><img alt="black-ball" src="img/black-ball.png"></div>\
					</div>';
            }
            html += '</div>';
        }
        html += '</div>';
        for (var key in shareLost) {
            if (typeof shareLost[key] === 'string' || shareLost[key] instanceof String) {
                if (shareLost[key].length > 0) {
                    var nameKEy = '';
                    if (key === 'preballs_sum') {
                        nameKEy = 'first_ball';
                    }
                    else {
                        nameKEy = key;
                    }
                    html +=
                        '<div id="shareOther">' +
                            translation[nameKEy].toUpperCase() + ' :  <span class="green">' + translation[shareLost[key].toLowerCase()].toUpperCase() + '</span>' +
                            '</div>';
                }
            }
            else {
                if (shareLost[key].length > 0) {
                    var nameKEy = '';
                    if (key === 'preballs_sum') {
                        nameKEy = 'first_ball';
                    }
                    else {
                        nameKEy = key;
                    }
                    html +=
                        '<div id="shareOther">' +
                            translation[nameKEy].toUpperCase() + ' :  ';
                    for (var ct = 0; ct < shareLost[key].length; ct++) {
                        html += ' <span class="separate">' + translation[shareLost[key][ct].toLowerCase()].toUpperCase() + '</span>';
                    }
                    html += '</div>';
                }
            }
        }
        return html;
    };
    return TicketPlayed;
}());
exports.default = TicketPlayed;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/ticket-played.ts
// module id = 1206
// module chunks = 0